// TronLink's browser extension announces itself as an EIP-6963 EVM provider
// so it shows up in EVM connect modals (Reown AppKit / wagmi) next to
// MetaMask. Selecting it there yields an EVM-only session and breaks the
// dedicated TronLink button used for TRON. Swallow its announcement at
// capture phase before wagmi's listener registers it. The TRON path is
// unaffected because TronContext talks to window.tronLink directly.
if (typeof window !== 'undefined') {
  window.addEventListener(
    'eip6963:announceProvider',
    (event) => {
      const info = event?.detail?.info || {};
      const name = (info.name || '').toLowerCase();
      const rdns = (info.rdns || '').toLowerCase();
      if (name.includes('tron') || rdns.includes('tron')) {
        event.stopImmediatePropagation();
      }
    },
    true,
  );
}

export {};
